/**
 * AP Software
 * AP Software REST API.
 *
 * OpenAPI spec version: 3.8.2
 * Contact: support@ap-software.de
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { User } from './user';

export interface Modification { 
    readonly id?: number;
    version?: number;
    created?: Date;
    updated?: Date;
    author?: User;
    readonly fieldName?: string;
    readonly operation?: Modification.OperationEnum;
    readonly oldValue?: string;
    readonly newValue?: string;
    readonly eTag?: string;
}
export namespace Modification {
    export type OperationEnum = 'DELETE' | 'REPLACE' | 'APPEND' | 'REMOVE';
    export const OperationEnum = {
        DELETE: 'DELETE' as OperationEnum,
        REPLACE: 'REPLACE' as OperationEnum,
        APPEND: 'APPEND' as OperationEnum,
        REMOVE: 'REMOVE' as OperationEnum
    };
}